import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ElementRef } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { formatDate } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'ngx-webstorage';
import { Quote } from '../../model/quote/quote.model';
import { AdminAlCalculationsComponent } from '../al-calculations/al-calculations.component';
import { AlQuoteService } from '../al-quote.service';
import { FinancialDetails } from '../../model/quote/financial_details.model';
import { AlCalculationsDetails } from '../al-calculations/al-calculations.model';
import { PolicyService } from '../../../../policy/policy.service';
import { PolicyHolderAddress } from '../../model/quote/policy_holder_address.model';
import { UserInfoService } from '../../../../services/user-info.service';


@Component({
  selector: 'app-admin-al-indicative-quote',
  templateUrl: './al-indicative-quote.component.html',
  styleUrls: ['../../../quote.component.css']
})
export class AdminAlIndicativeQuoteComponent implements OnInit {
  @Input() quoteDetails: Quote;
  @Output() quoteDetailsUpdated = new EventEmitter<Quote>();
  calculationDetails = new AdminAlCalculationsComponent();
  @Output() ProceedWithQuoteBtn = new EventEmitter();
  Calculations = new AlCalculationsDetails();
  currDate = new Date();
  isBroker: boolean = false;
  brokers = [];
  @Input()
  set allbrokers(value: any) {
    this.brokers = value;
  }

  policyReasons = [];
  @Input()
  set allPolicyReasons(value: any) {
    this.policyReasons = value;
  }

  constructor(private modalService: NgbModal, private quoteService: AlQuoteService, private _snackBar: MatSnackBar, private userService: UserInfoService,
    private sessionSt: LocalStorageService, private el: ElementRef, private route: ActivatedRoute, private policyService: PolicyService) { }


  ngOnInit(): void {
    this.quote = this.quoteDetails;
    // Set Quote Type
    if (this.route.snapshot.params.quote_type) {
      this.quote_type = Number(this.route.snapshot.params.quote_type);
    } else {
      this.quote_type = Number(this.quote.quote_versions[0].type);
    }
  }

  quote;
  minPolicyDate;
  maxPolicyDate;
  quote_type = 0;
  ngOnChanges(changes: SimpleChanges) {
    this.quote = this.quoteDetails;
    this.quote.calculations = this.Calculations;
    if (this.sessionSt.retrieve('company_role') == 'Broker') {
      let maxDate = new Date().setDate(new Date().getDate() + 30);
      this.maxPolicyDate = new Date(maxDate);
      this.minPolicyDate = new Date();
      this.isBroker = true;
      this.quote.company_id = this.sessionSt.retrieve('broker_company_id');
    }

    // Set Quote Type
    if (this.route.snapshot.params.quote_type) {
      this.quote_type = Number(this.route.snapshot.params.quote_type);
    } else {
      this.quote_type = Number(this.quote.quote_versions[0].type);
    }

    let uw_fees = 0;
    if (this.quote.quote_versions[0].financial_details) {
      uw_fees = this.quote.quote_versions[0].financial_details.uw_fees;
    } else {
      if (this.brokers) {
        let brokercomission = this.brokers.filter(x => x.id == this.quote.company_id);
        if (brokercomission.length > 0) {
          uw_fees = Number(brokercomission[0].uw_fees);
        }
      }
    }
    this.Calculations.administrative_charges = Number(uw_fees);
    this.Calculations.calculate_data(this.quote);
  }

  ngDoCheck() {
    // Set Quote Type
    if (this.route.snapshot.params.quote_type) {
      this.quote_type = Number(this.route.snapshot.params.quote_type);
    } else {
      this.quote_type = Number(this.quote.quote_versions[0].type);
    }
  }

  /*
  * HELP TEXT POPUP
  */
  helptext = '';
  helpTextPopup(content, text) {
    this.modalService.open(content, { centered: true });
    this.helptext = text;
  }

  /*
  * On Change Broker Dropdown
  */
 onChangeBroker(event) {
  let commission_percentage = 0;
  let uw_fees = 0;
  if (event.value) {
    let brokers_data = this.brokers.filter(x => x.id == event.value);

    if (brokers_data.length > 0) {
      commission_percentage = brokers_data[0].commission_percentage;
      uw_fees = brokers_data[0].uw_fees;
      this.quote.company_id = event.value;
    }
    this.quote.quote_versions[0].financial_details.administrative_charges = Number(uw_fees);
    
    this.Calculations.administrative_charges = Number(uw_fees);

    this.Calculations.calculate_data(this.quote);



  }
}

  /*
  * On Quote Type Change
  */
  onQuoteTypeChange(event) {
    this.quote_type = event.value;
    this.quote.quote_versions[0].type = event.value;
  }

  /*
  * ANIMAL ADDRESS CHANGE
  */
  onAnimalAddressChange(event) {
    if (event.value == 1) {
      this.quote.quote_versions[0].animal_address = new PolicyHolderAddress();
    }
  }


  /*
   * POSTCODE LOOKUP
   */
  addresses;
  postcodeLookup(event) {
    let postcode = event.target.value;
    this.quoteService.getAddressPostcodeLookup(postcode)
      .subscribe(
        (response: any) => {
          this.addresses = response.addresses;
        },
        (error) => {
          console.log(error);
        }
      );
  }
  onSelectAddress(address) {
    this.quote.quote_versions[0].policy_holder.address.address1 = address.line_1;
    this.quote.quote_versions[0].policy_holder.address.address2 = address.line_2;
    this.quote.quote_versions[0].policy_holder.address.city = address.town_or_city;
    this.quote.quote_versions[0].policy_holder.address.country = address.county;
  }
  onSelectAnimalAddress(address) {
    this.quote.quote_versions[0].animal_address.address1 = address.line_1;
    this.quote.quote_versions[0].animal_address.address2 = address.line_2;
    this.quote.quote_versions[0].animal_address.city = address.town_or_city;
    this.quote.quote_versions[0].animal_address.country = address.county;
  }
  /*
  * On Public Liability Change
  */
  onPublicLiabilityChange(event) {
    if (event.value == 2) {
      this.quote.quote_versions[0].alpaca_trailer_cover = null;
    }
  }
  /*
  * SAVE QUOTE
  */
  onSubmit(f: NgForm) {
    if (!f.form.valid) {
      for (const key of Object.keys(f.controls)) {
        if (f.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector('input[name=' + key + '], mat-select[name=' + key + '], textarea[name=' + key + ']');
          if (invalidControl) {
            invalidControl.focus();
            invalidControl.scrollIntoView({ behavior: 'smooth' });
          }
          break;
        }
      }

      return false;
    }
    let data: any = '';
    if (this.sessionSt.retrieve('company_role') != 'Broker') {
      this.sessionSt.store('al_broker_company_id', this.quote.company_id)
    }

    this.quote.quote_versions[0].quote_page_index = 0;

    this.quote.quote_versions[0].policy_start_date = formatDate(this.quote.quote_versions[0].policy_start_date, 'yyyy-MM-dd', 'en-US');
    if (this.quote.quote_versions[0].retroactive_date) {
      this.quote.quote_versions[0].retroactive_date = formatDate(this.quote.quote_versions[0].retroactive_date, 'yyyy-MM-dd', 'en-US');
    }

    if (!this.route.snapshot.params.quote_id) {
      this.quote.quote_versions[0].financial_details = new FinancialDetails();
    }
    
    if (this.quote.quote_versions[0].alpaca_public_liability_cover != 1) {

      this.quote.quote_versions[0].alpaca_trailer_cover = 0;
    }

    // For Policy Actions
    if (this.route.snapshot.params.quote_type) {
      this.quote.quote_versions[0].id = null;
      this.quote.quote_versions[0].about_alpaca.id = null;
      this.quote.quote_versions[0].about_alpaca.quote_id = null;
      this.quote.quote_versions[0].alpaca_liability.id = null;
      this.quote.quote_versions[0].alpaca_liability.quote_id = null;
      this.quote.quote_versions[0].smallholding_activities.id = null;
      this.quote.quote_versions[0].smallholding_activities.quote_id = null;
      this.quote.quote_versions[0].employer_liability.id = null;
      this.quote.quote_versions[0].trailer_cover.id = null;
      this.quote.quote_versions[0].trailer_cover.quote_id = null;
      this.quote.quote_versions[0].animal_type.id = null;
      //this.quote.quote_versions[0].animal_address.id = null;
      this.quote.quote_versions[0].alpaca_trailor_items.forEach((res, index) => {
        res.id = null;
      });
      this.quote.quote_versions[0].alpaca_details.forEach((res, index) => {
        res.id = null;
      });
      this.quote.quote_versions[0].financial_details.quote_id = null;
      this.quote.quote_versions[0].financial_details.id = null;
      this.quote.quote_versions[0].financial_details.alpaca_financials.id = null;
      this.quote.quote_versions[0].policy_holder.quote_id = null;
      this.quote.quote_versions[0].policy_holder.id = null;
      this.quote.quote_versions[0].statement_of_facts.forEach((res, index) => {
        res.quote_id = null;
        res.id = null;
      });


      this.quote.quote_versions[0].type = this.route.snapshot.params.quote_type;
    }

    switch (this.route.snapshot.params.quote_type) {
      case '4':
        this.quote.quote_versions[0].insurance_status_id = '7a877243-0919-4f92-8c35-6f5732013ca6';
        break;
      case '5':
        this.quote.quote_versions[0].insurance_status_id = '0c836e51-f8b0-4df8-8736-3ce56a40869f';
        break;
      case '6':
        this.quote.quote_versions[0].insurance_status_id = '9bcea739-fd0b-4c67-980c-9e0dadeb8445';
        break;
      default:
        this.quote.quote_versions[0].insurance_status_id = 'e216564f-552a-4e45-ae67-0a63b7074691';
        break;
    }

    let quote_temp = this.quote;
    data = {
      quote_data: this.quote
    };

    this.quoteService.saveQuote(data)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.quote = response.result.quote_data;
            this.quote.calculations = quote_temp.calculations;
            this.quoteDetailsUpdated.emit(this.quote);
            this.ProceedWithQuoteBtn.emit();
            this._snackBar.open(response.message, '', {
              duration: 5000,
            });
          } else {
            this._snackBar.open(response.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }

        });

  }
}
